const translations = {
  de: {
    and: "und",
    back: "Zurück",
    color: "Farbig",
    close: "Schließen",
    create: "Erzeuge",
    completed: "fertig",
    download: "Download",
    downloadMenu: "Download-Menü",
    downloadPdfMenu: "PDF-Download-Menü",
    downloadZipMenu: "ZIP-Download-Menü",
    dlFinish: "ist fertig",
    dlCreate: "wird erzeugt",
    firstPage: "Erste Seite",
    grey: "Grau",
    is: "ist",
    image: "Bild",
    images: "Bilder",
    //image: "Einzelbild",
    lastPage: "Letzte Seite",
    menu: "Menü",
    otherOptions: "Andere Download-Optionen",
    pages: "Seitenzahlen",
    pdfText: "Wählen Sie die Farbe, Qualität und die gewünschten Seiten aus.",
    preferences: "Einstellungen",
    quality: "Qualität",
    save: "speichern",
    title: "Link zum DFG-Viewer",
    warning: "Achtung: Die Erstellung kann etwas länger dauern.",
    zipText:
      "Laden Sie mehrere Bilder als Zip herunter. \nDer Download wird automatisch im Hintergrund gestartet.",
  },
  en: {
    and: "and",
    back: "Back",
    color: "Color",
    close: "Close",
    create: "Create",
    completed: "completed",
    download: "Download",
    downloadMenu: "Download menu",
    downloadPdfMenu: "PDF download menu",
    downloadZipMenu: "ZIP download menu",
    dlFinish: "is finished",
    dlCreate: "is created",
    firstPage: "First page",
    grey: "Grey",
    image: "Image",
    images: "Images",
    lastPage: "Last page",
    menu: "Menu",
    otherOptions: "Other download options",
    pages: "Page numbers",
    pdfText: "Choose the color, quality and the wanted pages.",
    preferences: "Preferences",
    quality: "Quality",
    save: "save",
    title: "Link to the DFG Viewer",
    warning: "Attention: The creation can take a little longer.",
    zipText:
      "Download multiple images as a zip.\nThe download will start automatically in the background.",
  },
};

export default translations;